import { useTranslation } from 'react-i18next';

import { GeneralTag } from '@/ui/tag/general-tag';
import { Icon } from '@/ui/icons/icon';
import { Flexbox } from '@/ui/flexbox/flexbox';
import type { PendingCompaniesListResponse } from '@/api/v4/projects.api';

type PendingCompanySourceTagProps = {
  source: PendingCompaniesListResponse['source'];
};

export const PendingCompanySourceTag = ({
  source,
}: PendingCompanySourceTagProps) => {
  const { t } = useTranslation('projects');

  const getSourceLabel = (
    sourceValue: PendingCompaniesListResponse['source'],
  ) => {
    switch (sourceValue) {
      case 'auto_enhance':
        return t('pendingProjects.sourceLabels.ai');
      case 'manual':
        return t('pendingProjects.sourceLabels.manual');
      case 'external_form':
        return t('pendingProjects.sourceLabels.externalForm');
      default:
        return sourceValue;
    }
  };

  return (
    <div data-testid="pending-company-source">
      <GeneralTag variant="purple" width="140px">
        <Flexbox justify="center" gap="4px" fullWidth>
          <Flexbox alignItems="center" gap="4px">
            <Icon icon="FileDoc" />
            {getSourceLabel(source)}
          </Flexbox>
        </Flexbox>
      </GeneralTag>
    </div>
  );
};
